// Headless export registration for the single-batch bars chart.
// The Component is the existing live BarsChart — no parallel duplicate. toProps
// adapts a setChartExportData payload into the props the live component expects.
//
// Chart-type keys follow Option A: 1:1 with the legacy pptx.coffee dispatch keys.
// `rb`, `cb`, `oex` are the answer-variant family (getAvParams) that all render
// as single-batch bars through this same component. Matrix keys (mx/sr/se/...)
// use the batched path and are registered in Phase 3.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/02-highcharts-bars.md §4.2

import { commonHcProps, registerHc } from '@aytm/app/stats/page/question-views/components/charts/lib/hc-exportable'
import { withWordCloudMode } from '@aytm/app/stats/page/question-views/components/word-cloud/wordCloudMode'

import BarsChart from '@aytm/app/stats/page/question-views/info-view/components/charts/bars/Chart'

// bars is the reference for the shared HC pattern: commonHcProps + the bars-specific
// tail. Output matches the pre-refactor inline toProps (zero regression). chartMode's
// 'respondents' default is spread AFTER commonHcProps so it overrides the raw core value.
registerHc(['rb', 'cb', 'oex'], withWordCloudMode(BarsChart, 'InfoViewBarsDispatcher'), (data: any, params: any) => ({
  ...commonHcProps(data, params),
  chartMode: params.chartMode || 'respondents',
  answerVariants: data.answerVariants,
  answerType: data.answerType,
  groupType: params.groupType || null,
  confidenceLevel: params.confidenceLevel,
  significanceLevel: params.significanceLevel,
  confidenceLevels: params.confidenceLevels,
  // chartMode 'wc' draws the block's answer variants as a word cloud instead of a chart.
  questionId: data.questionId,
  rType: data.rType,
  wcConfig: params.wcConfig,
  wcWidth: params.width,
  wcHeight: params.height
}))
